<template>
<v-chip v-if="item" color="green lighten-2">
  <template v-if="item.answerQuantity">
    <span v-for="(ans, j) in item.answerQuantity" :key="j">
      <!-- has value, comparator, unit code and codeSystem and displayName -->
      <span v-if="j > 0" class="mx-2">|</span>
      <span>{{ ans.value }}</span>
      <span v-if="ans.unit || ans.displayName">{{ ans.unit || ans.displayName }}</span>
      <span v-else-if="ans.code">{{ ans.code || ans.codeSystem }}</span>
    </span>
  </template>
  <template v-else-if="item.answerCoding">
    <span v-for="(ans, j) in item.answerCoding" :key="j">
      <span v-if="j > 0" class="mx-2">|</span>
      <!-- has code, codeSystem displayName and canonicalUri -->
      <span>{{ ans.displayName }} {{ ans.code }} {{ ans.codeSystem }}</span>
    </span>
  </template>
  <template v-else-if="item.answerDateTime">
     <span v-for="(ans, j) in item.answerDateTime" :key="j">
      <span v-if="j > 0" class="mx-2">|</span>
      <span>{{ $filters.formatDate(ans.value) }}</span>
    </span>
  </template>
  <template v-else-if="answerWithOnlyValue">
    <span v-for="(ans, j) in answerWithOnlyValue" :key="j">
      <span v-if="j > 0" class="mx-2">|</span>
      <span>{{ ans.value }}</span>
    </span>
  </template>
</v-chip>
</template>

<script>
export default {
  name: 'StructuralConditionAnswer',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    answerWithOnlyValue () {
      return (
        this.item.answerBoolean ||
        this.item.answerDecimal ||
        this.item.answerInteger ||
        this.item.answerDate ||
        this.item.answerDateTime ||
        this.item.answerTime ||
        this.item.answerString ||
        null
      )
    }
  }
}
</script>
